var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.canPurchaseRenewal()
    ? _c("div", [
        _c("div", { staticClass: "main-title" }, [
          _c("h2", [
            _vm._v(
              _vm._s(
                _vm.getTranslation("front", "subscription_renewal_box_title")
              )
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row justify-content-center mb-4" }, [
          _c("div", { staticClass: "col-md-12" }, [
            _c(
              "div",
              {
                staticClass:
                  "licenses__wrapper details-panel details-panel__white py-0 mt-0",
              },
              [
                _c(
                  "div",
                  { staticClass: "order-summary__body mb-5" },
                  [
                    _vm.showProlongButton()
                      ? [
                          _c(
                            "div",
                            { staticClass: "row d-flex align-items-center" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-md-8 col-12 d-flex align-items-center my-3",
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "align-middle" },
                                    [
                                      _vm._l(
                                        _vm.uniqueLeaseDates,
                                        function (uniqueDate) {
                                          return [
                                            _c("div", {
                                              staticClass: "renewalText",
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.getTranslation(
                                                    "lease-prolong-vue",
                                                    "product_subscription_renewal_for_date",
                                                    {
                                                      product:
                                                        uniqueDate.productName,
                                                      date: _vm.formatDateByLang(
                                                        uniqueDate.date
                                                      ),
                                                    }
                                                  )
                                                ),
                                              },
                                            }),
                                          ]
                                        }
                                      ),
                                    ],
                                    2
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-md-4 col-12 col-12 d-flex  my-3",
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "btn btn-order",
                                      attrs: {
                                        onclick:
                                          "window.productList.goToKeySetup();",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.getTranslation(
                                            "lease-prolong-vue",
                                            "renew_now"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(_vm.products, function (product) {
                      return _vm.leaseProlongPrice[product.id]
                        ? [
                            _vm.leaseProlongPrice[product.id]
                              ? _c(
                                  "div",
                                  { staticClass: "lease-prolong-row" },
                                  [
                                    _vm.isTruss4Product(product.id)
                                      ? [
                                          _c("lease-prolong", {
                                            attrs: { product: product.id },
                                          }),
                                        ]
                                      : _vm._e(),
                                  ],
                                  2
                                )
                              : _vm._e(),
                          ]
                        : _vm._e()
                    }),
                  ],
                  2
                ),
              ]
            ),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }